import { jsx as r } from "react/jsx-runtime";
const n = (t) => ({ ...e }) => /* @__PURE__ */ r(t, { sortable: !0, ...e });
export {
  n as default
};
//# sourceMappingURL=withSortableElement.js.map
